// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--og8Ih","wrapper":"_9330de7794--wrapper--sHmsE","title":"_9330de7794--title--TCrIS"};